import { useRef } from 'react'
import PropTypes from 'prop-types'

import Icon from '../Icons'
import { useClickOutside } from '../../helpers/hooks/useClickOutside'

const SelectListWindow = ({ availableList, onCancel, onChoose }) => {
  const ref = useRef(null)
  useClickOutside(ref, () => onCancel())

  return (
    <div className="select-list-window">
      <div className={`select-list-window__container`} ref={ref}>
        <div className="window-header">
          <div className="title">Select option</div>
          <div className="navi-button" onClick={onCancel}>
            <Icon icon="cross" />
          </div>
        </div>
        <div className="window-body">
          {availableList.length &&
            availableList.map((item) => {
              return (
                <div key={item.id} className="select-option" onClick={() => onChoose(item)}>
                  {item.value}
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

SelectListWindow.propTypes = {
  availableList: PropTypes.array,
  onCancel: PropTypes.func,
  onChoose: PropTypes.func,
}

export default SelectListWindow
